/**
 * @generated SignedSource<<f602929c3d0dfd47adac36481126643b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HubTemplateEnum = "HOME_LANDING_PAGE" | "HUB_TEMPLATE_03" | "SALES_LANDING_PAGE";
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type SetConnectionHubToHpsFromKeysEnum = "hubId" | "pageId";
export type StatusUiPermissionEnum = "PUBLIC" | "RESTRICTED";
export type CreateHubInput = {
  authorId?: string | null | undefined;
  content?: string | null | undefined;
  created?: string | null | undefined;
  description?: string | null | undefined;
  group?: string | null | undefined;
  metadata?: HubMetadataInput | null | undefined;
  modified?: string | null | undefined;
  postOrder?: number | null | undefined;
  setConnectionHubToHps?: SetConnectionHubToHpsInput | null | undefined;
  slug?: string | null | undefined;
  status?: PostStatusEnum | null | undefined;
  statusSettings?: StatusSettingsInput | null | undefined;
  template?: HubTemplateEnum | null | undefined;
  title: string;
  userId?: string | null | undefined;
  userMeta?: HubUserMetaInput | null | undefined;
};
export type HubMetadataInput = {
  design?: HubMetadataDesignInput | null | undefined;
  navMeta?: ReadonlyArray<HubMetadataNavMetaInput | null | undefined> | null | undefined;
  shareIcons?: ReadonlyArray<HubMetadataShareIconsInput | null | undefined> | null | undefined;
};
export type HubMetadataDesignInput = {
  borderRadius?: number | null | undefined;
};
export type HubMetadataNavMetaInput = {
  icon?: string | null | undefined;
  title?: string | null | undefined;
  znglistId?: string | null | undefined;
};
export type HubMetadataShareIconsInput = {
  icon?: string | null | undefined;
  title?: string | null | undefined;
  url?: string | null | undefined;
};
export type SetConnectionHubToHpsInput = {
  deleteNonIncluded?: boolean | null | undefined;
  fromId?: string | null | undefined;
  fromKey?: SetConnectionHubToHpsFromKeysEnum | null | undefined;
  nodes?: ReadonlyArray<SetConnectionHubToHpsNodeInput | null | undefined> | null | undefined;
};
export type SetConnectionHubToHpsNodeInput = {
  hubId?: string | null | undefined;
  pageIcon?: string | null | undefined;
  pageId?: string | null | undefined;
  pageOrder?: number | null | undefined;
  pageTitle?: string | null | undefined;
};
export type StatusSettingsInput = {
  approved?: ApprovedStateInput | null | undefined;
  stateWhenApproved?: StateWhenApprovedInput | null | undefined;
  status?: PostStatusEnum | null | undefined;
  uiPermission?: UIPermissionInput | null | undefined;
};
export type ApprovedStateInput = {
  id?: string | null | undefined;
};
export type StateWhenApprovedInput = {
  status?: PostStatusEnum | null | undefined;
  uiPermission?: UIPermissionInput | null | undefined;
};
export type UIPermissionInput = {
  type?: StatusUiPermissionEnum | null | undefined;
};
export type HubUserMetaInput = {
  description?: string | null | undefined;
  imageId?: string | null | undefined;
  name?: string | null | undefined;
  role?: string | null | undefined;
};
export type Hub_Create_Mutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateHubInput;
};
export type Hub_Create_Mutation$data = {
  readonly createHub: {
    readonly hub: {
      readonly author: {
        readonly node: {
          readonly id: string;
          readonly name: string | null | undefined;
          readonly slug: string | null | undefined;
          readonly username: string | null | undefined;
        };
      } | null | undefined;
      readonly id: string;
      readonly modified: string | null | undefined;
      readonly slug: string | null | undefined;
      readonly status: PostStatusEnum | null | undefined;
      readonly title: string;
    } | null | undefined;
  } | null | undefined;
};
export type Hub_Create_Mutation = {
  response: Hub_Create_Mutation$data;
  variables: Hub_Create_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modified",
      "storageKey": null
    },
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NodeWizAuthorToUserConnectionEdge",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "username",
              "storageKey": null
            },
            (v4/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "Hub_Create_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreateHubPayload",
        "kind": "LinkedField",
        "name": "createHub",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "Hub_Create_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreateHubPayload",
        "kind": "LinkedField",
        "name": "createHub",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "hub",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "HubPage"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4ed051958e0d042231fea54c5374b877",
    "id": null,
    "metadata": {},
    "name": "Hub_Create_Mutation",
    "operationKind": "mutation",
    "text": "mutation Hub_Create_Mutation(\n  $input: CreateHubInput!\n) {\n  createHub(input: $input) {\n    hub {\n      id\n      title\n      status\n      modified\n      slug\n      author {\n        node {\n          id\n          name\n          username\n          slug\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c5d71cf488c6e10c8d6c5f00f784712f";

export default node;
